<template>
  <v-card outlined class="my-3" ref="cardRef" :class="{ centeredCard: displayMode.isFeed }">
    <v-card-subtitle class="mt-0">
        <img :src="page.sourceIcon" class="sourceIcon mr-2" v-if="page.sourceIcon" />
        <v-row class="mt-2" v-if="displayMode.isFeed">
            <v-col cols="6" class="pa-0">
                {{ item.from_entry }}
                <media-type-badge :media-types="item.media_types" class="ml-1" />
            </v-col>
            <v-col cols="6" class="pa-0 text-right">
                {{ `${item.publication_date.dd}/${item.publication_date.mm}/${item.publication_date.yyyy}` }} {{ item.publication_date.time }}
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12" class="pa-0 pt-4">
                {{ item.from_entry }}
                <media-type-badge :media-types="item.media_types" class="ml-1" />
            </v-col>
            <v-col cols="12" class="pa-0 text-right">
                {{ `${item.publication_date.dd}/${item.publication_date.mm}/${item.publication_date.yyyy}` }} {{ item.publication_date.time }}
            </v-col>
        </v-row>
    </v-card-subtitle>
    <v-card-title :class="[{ ['pt-0']: displayMode.isMasonry }, 'font-weight-semibold']">
        <a :href="item.url" 
            target="_blank" 
            v-if="item.title !== item.description"
        >
            {{ item.title }}
        </a>
        <a :href="item.url" target="_blank" v-else>{{ item.url }}</a>
    </v-card-title>
    <v-card-text class="text-center">
      <img
        v-if="item.preview && item.preview.length > 0 && !page.imageError"
        :src="item.preview"
        :class="{ previewImg: displayMode.isFeed, smallPreviewImg: displayMode.isMasonry }"
        @error="handleImageError"
      />
    </v-card-text>
    <v-card-text class="font-weight-regular text-base description">
      {{ item.description }}
    </v-card-text>
  </v-card>
</template>

<style scoped>
/*
font-weight-medium
font-weight-thin
text-base 
*/
.centeredCard {
  width: 40rem; 
  margin: auto;
}

.previewImg {
  max-width: 30rem;
  max-height: 30rem;
}

.smallPreviewImg {
  max-width: 15rem;
  max-height: 20rem;
}

.sourceIcon {
  float: left;
  max-width: 2rem;
  max-height: 2rem;
}

.description {
  text-align: justify;
  text-justify: auto;
}
</style>

<script>
import { computed, onMounted, reactive, ref } from "@vue/composition-api";

import useProxy from "@/hooks/useProxy";
import MediaTypeBadge from "@/components/news-radar/db/parts/MediaTypeBadge.vue";

export default {
  name: "FeedResults",
  components: { MediaTypeBadge },
  props: {
    item: {
      type: Object,
      required: true,
      validator: (value) => {
        const givenKeys = Object.keys(value);
        const requiredKeys = [
            "description", 
            "from_entry", 
            "preview", 
            "publication_date", 
            "source", 
            "title", 
            "url",
        ];
        if (!requiredKeys.every(key => givenKeys.includes(key))) {
            return false;
        }

        const dateGivenKeys = Object.keys(value.publication_date);
        const dateRequiredKeys = ["date", "yyyy", "mm", "dd", "time"];

        return dateRequiredKeys.every(key => 
          dateGivenKeys.includes(key));
      }
    }
  },
  setup(props, { emit }) {
    const { store } = useProxy();

    const cardRef = ref(null);
    const page = reactive({
      imageError: false,
      sourceIcon : null,
    });

    // =>  METHODS
    const handleImageError = () => {
        page.imageError = true;
    };

    const defineIcon = (source) => {
      switch(source) {
          case 'GoogleNews':
              page.sourceIcon = "/icons/sources/google_news.png";
              break;

          case 'Gtrend':
              page.sourceIcon = "/icons/sources/google_trends.png";
              break;

          case "Instagram (via RssApp)":
              page.sourceIcon = "/icons/sources/instagram.png";
              break;
          
          case 'Marfeel':
              page.sourceIcon = "/icons/sources/marfeel.png";
              break;
          
          case 'Perplexity':
              page.sourceIcon = "/icons/sources/perplexity.png";
              break;
          
          case 'Concurrency':
          case "Website (via RssApp)":
              page.sourceIcon = "/icons/sources/rss.png";
              break;
          
          case 'Reddit':
              page.sourceIcon = "/icons/sources/reddit.png";
              break;

          case "Rappel Conso":
              page.sourceIcon = "/icons/sources/rappel_conso.png";
              break;

          case "X (via RssApp)":
              page.sourceIcon = "/icons/sources/x.png";
              break;

          case "Tiktok (via RssApp)":
              page.sourceIcon = "/icons/sources/tiktok.png";
              break;

          case "Linkedin (via RssApp)":
              page.sourceIcon = "/icons/sources/linkedin.png";
              break;

          /* case "Website (via RssApp)":
              page.sourceIcon = "/icons/sources/html.png";
              break; */
          
          case 'Youtube':
              page.sourceIcon = "/icons/sources/youtube.png";
              break;

          default:
              break; 
      }
    };

    // =>  COMPUTED
    const displayMode = computed(() => store.getters['newsRadar/getDisplayMode']);

    // =>  WATCH

    // =>  HOOKS
    onMounted(() => {
      defineIcon(props.item.source);
      
      // Wait for component to actually be mounted
      setTimeout(() => {
        if (cardRef.value) {
          emit('height-calculated', cardRef.value.$el.offsetHeight);
        }
      }, 0);
    });

    // =>  DATA
    return {
      cardRef,
      displayMode: {
        isFeed: displayMode.value === 'feed',
        isMasonry: displayMode.value === 'masonry',
      },
      handleImageError,
      page,
    };
  },
};
</script>
